import React from 'react'
import { Datagrid, TextField } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import DeleteAndExportBulk from 'ui-shared/BulkActionGroups/DeleteAndExportBulk'
import KPagination from 'ui-shared/KPagination'
import { BaseListProps } from 'ui-shared/WrappedInputs/CatalogItemBaseList'
import KList from 'ui-shared/KWrappers/KList'

const OrganizationList: React.FC<BaseListProps> = (props) => {
  return (
    <SectionWrapper>
      <KList
        {...props}
        exporter={false}
        pagination={<KPagination />}
        perPage={40}
      >
        <Datagrid rowClick="edit" bulkActionButtons={<DeleteAndExportBulk />}>
          <TextField
            source="name"
            label="form.fields.organizationName"
            sortable={false}
          />
          <TextField
            source="responsibleFullName"
            label="form.fields.responsibleFullName"
            sortable={false}
          />
        </Datagrid>
      </KList>
    </SectionWrapper>
  )
}

export default OrganizationList
